const mapTitle = (path: string): string => {
  switch(path) {
    default:
      return '浙江宜尔阳光教育基金会';
  }
};

export default mapTitle;